import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "w-full"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectDocs',
    props: {
        items: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_UList = _resolveComponent("UList");
            const _component_UContent = _resolveComponent("UContent");
            return (props.items.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_UContent, {
                        padding: "15px",
                        "header-align": "space-between",
                        "header-padding": "0px 0px 15px 0px",
                        "has-title-delimiter": false
                    }, {
                        "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", { class: "flex items-center gap-2" }, [
                                    _createElementVNode("span", null, "Documents")
                                ], -1)
                            ]))]),
                        content: _withCtx(() => [
                            _createVNode(_component_UList, null, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "flex items-center h-5"
                                        }, [
                                            _createVNode(_component_UIcon, {
                                                href: item.link,
                                                icon: "/img/project-card/file-icon.svg",
                                                "is-link": true,
                                                "icon-size": "26px",
                                                class: "pb-1"
                                            }, null, 8, ["href"]),
                                            _createVNode(_component_RouterLink, {
                                                to: item.link,
                                                target: "_blank",
                                                class: "link"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.name), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to"])
                                        ]));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
